import { makeStyles, type Theme } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
  scheduleSuccessGridContainer: {
    flexDirection: "column",
    margin: "16px 0 0",
  },
  successTitle: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    textAlign: "center",
  },
  scheduleSuccessGrid: {
    margin: "16px auto",
  },
  bigIcon: {
    width: "260px",
    height: "180px",
  },
  divider: {
    width: "100%",
    margin: "10px 0px",
    padding: "0",
  },
  locationTitle: {
    fontFamily: "Lato",
    textAlign: "center",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    color: "#0F172A",
  },
  datetimeTitle: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    textAlign: "center",
    color: "#0F172A",
  },
  tooltip: {
    background: "#D9E7F0",
    color: "#235693",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: "18px",
  },
  arrowToolTip: {
    color: "#D9E7F0",
  },
  editIconButton: {
    margin: "6px 4px 4px",
    border: "1px solid #D9E7F0",
    "& > .MuiIconButton-label": {
      position: "relative",
      top: "-1px",
      right: "-2px",
    },
  },
  zoomTipContainer: {
    margin: "12px 0",
    padding: "9px 14px",
    backgroundColor: "#FBFBFC",
    border: "1px solid #D9E7F0",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    gap: "10px",
  },
  zoomTipIcon: {
    marginTop: "6px",
  },
  zoomTip: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    color: "#17295B",
  },
  addTo: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: "#0344DC",
  },
  tips: {
    backgroundColor: "#E9FBF8",
    borderRadius: "8px",
    margin: "20px 0 20px 0",
    padding: "24px 0 16px",
    "& > .MuiGrid-item:first-child": {
      display: "flex",
      justifyContent: "center",
    },
  },
  tipsTitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    color: "#00A3A3",
    marginLeft: "10px",
  },
  tipsText: {
    fontSize: theme.typography.pxToRem(16),
    color: "#00A3A3",
    margin: "12px 16px 0",
    fontWeight: 400,
    lineHeight: "22.4px",
    textAlign: "center",
  },
}));
